import SM404 from '../../containers/404'

export const Screen404: React.FC = () => {
    // ======================= VIEWS
    return (
        <>
            <SM404 />
        </>
    )
}

// ======================= EXPORT
export default Screen404
